import "../styles/MoreInfo.css"

const MoreInfo = () => {
    return <div className="lmj-moreinfo">
        Ce site à été réalisé dans le cadre du cours OpenClassrooms <i><a href="https://openclassrooms.com/fr/courses/7008001-debutez-avec-react">Débutez avec React</a></i>. Pour plus d'informations sur le process de création, je vous invite à aller voir <a href="https://danlcarton.notion.site/OPENCLASSROOMS-DEBUTEZ-AVEC-REACT-4a107551444f4f048a734d27818808bd?pvs=4">ce Notion</a> compilant mes notes et mes avancées.
    </div>
}

export default MoreInfo